import { getTimezoneOffset } from 'date-fns-tz';

export const TIMEZONE_ALIASES = {
  FURTHER_EASTERN_EUROPE: 'Europe/Minsk',
  EASTERN_EUROPE: 'EET',
  CENTRAL_EUROPE: 'CET',
  WESTERN_EUROPE: 'WET',
  ATLANTIC: 'Atlantic/Bermuda',
  EASTERN: 'EST5EDT',
  CENTRAL: 'CST6CDT',
  MOUNTAIN: 'MST7MDT',
  PACIFIC: 'PST8PDT',
  ALASKA: 'US/Alaska',
  HAWAII: 'US/Hawaii'
};

export const TIMEZONES_OFFSET_OPTIONS = Object.entries(TIMEZONE_ALIASES).map(
  ([alias, timezone]) => ({
    value: getTimezoneOffset(timezone) / 1000 / 60,
    key: alias,
    timezone
  })
);

export const getTimezoneByOffset = (offset: number) =>
  TIMEZONES_OFFSET_OPTIONS.find(({ value }) => -value === offset)?.timezone;
